import {EGroup} from './types';

export default {
  select: 'Выбор emoji',
  search: 'Поиск',
  searchResult: 'Результат поиска',
  notFound: 'Emoji не найден',
  empty: 'Пусто',
  group: {
    [EGroup.recent]: 'Часто используемые',
    [EGroup.recent]: 'Часто используемые',
    [EGroup.smileys]: 'Смайлы и эмоции',
    [EGroup.people]: 'Люди',
    [EGroup.animals_and_nature]: 'Животные и природа',
    [EGroup.food_and_drink]: 'Еда и напитки',
    [EGroup.activity]: 'Действия',
    [EGroup.travel_and_places]: 'Путешествие и места',
    [EGroup.objects]: 'Объекты',
    [EGroup.symbols]: 'Символы',
    [EGroup.flags]: 'Флаги',
  },
};
